import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store';
import { getWatchGateStatus } from '../watch/featureGate';

export function useWatchCompanion() {
  const settings = useSelector((state: RootState) => state.session.settings) as Record<string, unknown> | null;
  const accountFeatures = useSelector((state: RootState) => state.session.account?.features) as
    | Record<string, unknown>
    | null
    | undefined;

  return useMemo(
    () =>
      getWatchGateStatus({
        settings,
        accountFeatures: accountFeatures || null,
      }),
    [settings, accountFeatures]
  );
}

export default useWatchCompanion;
